// Central brand tokens for CarelyNest
export const C = {
  teal: '#14675A',
  tealDeep: '#153A33',
  tealDark: '#122F29',
  orange: '#E07C45',
  orangeDark: '#C9662F',
  orangeSoft: '#E9A97E',
  cream: '#FBF7F0',
  creamCard: '#F4EFE4',
  sage: '#EFF4F0',
  sageTint: '#EAF2EE',
  ink: '#1B2A25',
  body: '#4C5B55',
  muted: '#5E6E68',
  line: '#EAE4D8',
  waGreen: '#25A05A',
  waGreenDark: '#1E8A4C',
};

export const F = {
  serif: "'Newsreader', Georgia, serif",
  sans: "'Mulish', system-ui, -apple-system, sans-serif",
};

// Images live in /public/assets so they resolve regardless of build path
export const IMG = `${process.env.PUBLIC_URL}/assets`;

export const WHATSAPP_URL = 'https://wa.me/2348125777959';
export const EMAIL = 'care@carelynest.org';
